<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>
<!-- Modal Editar Submarca -->
<div class="modal">
  <a class="close" (click)="cancel()">Cerrar</a>
  <h1>{{ isEdit ? "Editar submarca" : "Nueva submarca" }}</h1>
  <div class="editarSubmarca">
    <form [formGroup]="form" (ngSubmit)="create()">
      <div class="wrapper">
        <div>
          <div class="controlWrapper">
            <label>Nombre<span class="required">*</span></label>
            <div>
              <input type="text" formControlName="name" />
              <div
                *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
              >
                <small class="error" *ngIf="form.get('name')?.errors?.['required']">El nombre es requerido</small>
                <small class="error" *ngIf="form.get('name')?.errors?.['duplicateName']">Nombre duplicado en esta marca</small>
              </div>
            </div>
          </div>
          <!--
          <div class="controlWrapper">
            <label>Código<span class="required">*</span></label>
            <div>
              <input type="text" formControlName="subBrandCode" class="size2" />
              <div
                *ngIf="form.get('subBrandCode')?.invalid && form.get('subBrandCode')?.touched"
              >
                <small class="error">El código es requerido</small>
              </div>
            </div>
          </div>
          -->
          <div class="controlWrapper">
            <label
              >Marca a la que pertenece<span class="required">*</span></label
            >
            <div class="customSelect">
              <select
                formControlName="brandId"
                Placeholder="Selecciona una marca"
              >
                <option [value]="null" disabled selected hidden>Selecciona una marca</option>
                <option *ngFor="let brand of brands" [ngValue]="brand.id">
                  {{ brand.name }}
                </option>
              </select>
              <div
                *ngIf="
                  form.get('brandId')?.invalid && form.get('brandId')?.touched
                "
              >
                <small class="error">Debes seleccionar una marca</small>
              </div>
            </div>
          </div>
          <label class="switch gapTop">
            <input type="checkbox" formControlName="enabled" />
            <span class="knob"></span>
            <span class="base"></span>
            <span class="description">Habilitado</span>
          </label>
        </div>
        <div>
          <app-input-file-select
            [label]="'Imagen'"
            [required]="false"
            uploadTitle="Hacer clic o arrastrar archivo aquí"
            uploadSubTitle="Formato JPG o PNG, tamaño 600 x 400 px."
            [defaultFile]="defaultFile()"
            [isValidSelected]="hasFile"
            [validationConfig]="subBrandImageConfig"
            (onSelected)="onFileSelected($event)"
            (onRemoved)="removeImage()"
          />
        </div>
      </div>
      <div class="actions">
        <div class="wrapper">
          <button type="button" class="secondary" (click)="cancel()">
            Cancelar
          </button>
          <button type="submit" class="primary" [disabled]="!isFormValid">
            {{ isEdit ? "Aceptar" : "Crear" }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
